import { render } from "./App.vue?vue&type=template&id=23ca4b31"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__